import { createAsyncThunk } from '@reduxjs/toolkit';

import { urlJoinP } from 'url-join-ts';

import { createAxiosInstance } from '@app/common';
import { SliceNameEnum } from '@app/enums';
import { environment } from '@app/environments/environment';
import { MapAccommodationModel } from '@app/models/elastic-search';

export const getAccommodationForMap = createAsyncThunk<
    { id: string; data: MapAccommodationModel },
    string
>(`${SliceNameEnum.MapAccommodation}/fetch`, async (id, { rejectWithValue }) => {
    try {
        const axios = createAxiosInstance();
        const response = await axios.get(
            urlJoinP(environment.SSR_API_HOST, ['accommodation', 'map', `${id}`, '/']),
        );

        return {
            id,
            data: response.data,
        };
    } catch (err) {
        return rejectWithValue([err].flat());
    }
});
